import * as React from 'react';
import {connect} from 'react-redux';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import authDispatch from '../../ReduxRequests/Dispatch/authDispatch';
import {URL} from '../../Config/appConfig';
import Modal from '../Modal/Modal';

interface IdleProps {
    logout: () => void,
    onCancel: () => void
}

interface IdleState {
    time: { h: number, m: number, s: number },
    seconds: number,
    loading: boolean
}

class Idle extends React.Component <RouteComponentProps & IdleProps, IdleState> {
	public timer;

    public constructor(props: IdleProps) {
        super(props);
        this.state = {
            time: {h: 0, m: 0, s: 0},
            seconds: 60 * 2,
            loading: false
        };
        this.clickLogout = this.clickLogout.bind(this);
        this.clickCancel = this.clickCancel.bind(this);
        this.countDown = this.countDown.bind(this);
        this.paddingLeft = this.paddingLeft.bind(this);
    }

    public componentWillUnmount() {
        if (this.timer) clearInterval(this.timer);
    }

    public componentDidMount() {
        let timeLeftVar = this.secondsToTime(this.state.seconds);
        this.setState({time: timeLeftVar});
        this.timer = setInterval(this.countDown, 1000);
    }

    public secondsToTime(secs: number) {
        const hours = Math.floor(secs / (60 * 60));
        const divisorForMinutes = secs % (60 * 60);
        const minutes = Math.floor(divisorForMinutes / 60);
        const divisorForSeconds = divisorForMinutes % 60;
        const seconds = Math.ceil(divisorForSeconds);
        return {
            "h": hours,
            "m": minutes,
            "s": seconds
        };
    }

    public countDown() {
        let seconds = this.state.seconds - 1;
        this.setState({
            time: this.secondsToTime(seconds),
            seconds,
        });

        if (seconds === 0) {
            clearInterval(this.timer);
            this.logout();
        }
    }

    public paddingLeft(number: number) {
        if (typeof number === 'number' && number.toString().length === 1) return '0' + number;
        else return number;
    }

    public clickCancel(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        clearInterval(this.timer);
        this.props.onCancel();
    }

    public clickLogout(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        this.logout();
    }

    public logout() {
        clearInterval(this.timer);
        this.props.logout();
        this.props.history.push(URL.SESSION_EXPIRED);
    }

    public render() {
        let content = (
			<div className="cmText modalText modalTextSm">
				We want to keep you safe! Due to inactivity, your secure connection will expire in {this.paddingLeft(this.state.time.m)}:{this.paddingLeft(this.state.time.s)}.
				<br/><br/>
				Do you want to stay signed in?
			</div>
        );
        return (
			<Modal
				content={content}
				leftBtn="Yes, keep me signed in"
				rightBtn="No, sign me out"
				clickCancel={this.clickCancel}
				clickConfirm={this.clickLogout}/>
        );
    }
}

export default withRouter(connect(null, authDispatch)(Idle));



// WEBPACK FOOTER //
// ./src/Components/Auth/Idle.tsx